import Sidebar from './SideBar.vue';
import SidebarLink from './SidebarLink.vue';
import SidebarItem from './SidebarItem.vue';

const SidebarPlugin = {
  install(Vue) {
    const SidebarStore = Vue.observable({   // 👈 aquí dentro
      showSidebar: "opened",
      toggleSidebar: false,
      sidebarLinks: [
        {
          name: 'Dashboard',
          icon: 'ti-panel',
          path: '/admin/overview'
        }
      ],
      displaySidebar(value) {
        this.showSidebar = value;
      }
    });

    Vue.prototype.$sidebarStore = SidebarStore;
    Vue.prototype.$sidebar = SidebarStore; // 👈 alias para compatibilidad

    Vue.component('side-bar', Sidebar);
    Vue.component('sidebar-link', SidebarLink);
    Vue.component('sidebar-item', SidebarItem);
  }
};

export default SidebarPlugin;
